import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, Transitions } from "../../types"

export const collapsableSectionsState: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  on: {
    EXPAND_ALL: {
      actions: assign((ctx, _evt) => ({
        expanded: (ctx.studyPlan ?? ctx.publishedStudyPlan).sections.map(
          ({ id }) => id
        )
      }))
    },
    COLLAPSE_ALL: {
      actions: assign((_ctx, _evt) => ({ expanded: [] }))
    },
    TOGGLE_EXPAND_SECTION: {
      actions: assign((ctx, { sectionId }) => ({
        expanded: ctx.expanded.includes(sectionId)
          ? ctx.expanded.filter(id => id !== sectionId)
          : [...ctx.expanded, sectionId]
      }))
    }
  }
}
